import { c as _c } from "react/compiler-runtime";
import { useCountdown } from '@onefootprint/hooks';
import { getBasicDevice, getLogger, HeaderTitle, NavigationHeader, useUpdateD2PStatus } from '@onefootprint/idv';
import { D2PStatusUpdate } from '@onefootprint/types';
import { Shimmer } from '@onefootprint/ui';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import useHandoffMachine from '../../hooks/use-handoff-machine';
const SUCCESS_COUNTER_SECONDS = 3;
const {
  logError,
  logInfo
} = getLogger({
  location: 'handoff-complete'
});
const Complete = () => {
  const $ = _c(25);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "pages.complete"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("common", t0);
  const updateD2PStatusMutation = useUpdateD2PStatus();
  const [state] = useHandoffMachine();
  const {
    authToken,
    opener
  } = state.context;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = getBasicDevice();
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const device = t1;
  const isMobile = device.type === "mobile";
  const isOpenerMobile = opener === "mobile";
  const isHandoffOnSameDevice = isOpenerMobile === isMobile;
  const t2 = !isHandoffOnSameDevice;
  let t3;
  if ($[2] !== t2) {
    t3 = {
      disabled: t2,
      onCompleted: _temp
    };
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const {
    countdown,
    setSeconds
  } = useCountdown(t3);
  const [hasFinished, setHasFinished] = useState(false);
  let t4;
  if ($[4] !== authToken || $[5] !== isHandoffOnSameDevice || $[6] !== setSeconds || $[7] !== updateD2PStatusMutation) {
    t4 = async () => {
      if (authToken) {
        ;
        try {
          await updateD2PStatusMutation.mutateAsync({
            authToken,
            status: D2PStatusUpdate.completed
          });
          logInfo("Handoff complete, d2p marked completed", {
            isHandoffOnSameDevice
          });
        } catch (t5) {
          const err = t5;
          logError("Failed to mark d2p completed", err, {
            isHandoffOnSameDevice
          });
        }
      }
      setSeconds(SUCCESS_COUNTER_SECONDS);
      setHasFinished(true);
    };
    $[4] = authToken;
    $[5] = isHandoffOnSameDevice;
    $[6] = setSeconds;
    $[7] = updateD2PStatusMutation;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const handleComplete = t4;
  let t5;
  if ($[9] !== handleComplete) {
    t5 = () => {
      handleComplete();
    };
    $[9] = handleComplete;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = [];
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  useEffect(t5, t6);
  if (!hasFinished) {
    let t7;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
      t7 = <div className="flex flex-col items-center justify-center h-full text-center"><div className="flex flex-col items-center gap-3"><Shimmer height="28px" width="120px" className="mb-2" /><Shimmer height="24px" width="288px" /></div></div>;
      $[12] = t7;
    } else {
      t7 = $[12];
    }
    return t7;
  }
  let t7;
  if ($[13] !== countdown || $[14] !== isHandoffOnSameDevice || $[15] !== t) {
    t7 = () => {
      if (!isHandoffOnSameDevice) {
        return t(_temp2, {
          seconds: countdown
        });
      }
      if (countdown === 1) {
        return t(_temp3, {
          seconds: countdown
        });
      }
      if (countdown === 0) {
        return t(_temp4, {
          seconds: countdown
        });
      }
      return t(_temp5, {
        seconds: countdown
      });
    };
    $[13] = countdown;
    $[14] = isHandoffOnSameDevice;
    $[15] = t;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  const getSubtitle = t7;
  let t8;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <NavigationHeader />;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t) {
    t9 = t(_temp6);
    $[18] = t;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== getSubtitle) {
    t10 = getSubtitle();
    $[20] = getSubtitle;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t10 || $[23] !== t9) {
    t11 = <div className="flex flex-col items-center justify-center h-full text-center"><div>{t8}<HeaderTitle title={t9} subtitle={t10} /></div></div>;
    $[22] = t10;
    $[23] = t9;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  return t11;
};
export default Complete;
function _temp() {
  return window.close();
}
function _temp2($) {
  return $.subtitle.withoutCountdown;
}
function _temp3($_0) {
  return $_0.subtitle.withCountdownSingular;
}
function _temp4($_1) {
  return $_1.subtitle.withCountdownZero;
}
function _temp5($_2) {
  return $_2.subtitle.withCountdown;
}
function _temp6($_3) {
  return $_3.title;
}